export const LOGIN_API = '/login';
export const GET_LOGGED_IN_USER_API = '/users/user/get-logged-in-user'; // userId
// =========================
// Mailing list
// =========================
export const SUBSCRIBE_TO_MAILING_LIST_API = '/mailing-list/subscribe-to-mailing-list';
export const MAILING_LIST_VALIDATE_EMAIL_API = '/mailing-list/confirm-email';
export const MAILING_LIST_UNSUBSCRIBE_API = '/mailing-list/unsubscribe'; // email
export const MAILING_LIST_RESEND_VALIDATE_EMAIL_API = '/mailing-list/resend-verification-email';

export const GET_ALL_MAILING_LIST_SUBSCRIBERS_API = '/mailing-list/get-subscriber-list';
export const DELETE_SUBSCRIBER_BY_ID_API = '/mailing-list/delete-subscriber-by-id';
export const DELETE_ALL_SUBSCRIBERS_API = '/mailing-list/delete-all-subscribers';